/**
 * Ensure api.video session token (avh) is on every HLS request.
 * - Resolves relative sub-request URLs against the manifest URL (so aud/manifest.m3u8 etc. become absolute).
 * - Uses the token from the manifest URL when adding avh so we never mix tokens (avoids 404).
 */

/**
 * @param {string} requestUrl - URL from HLS.js (may be relative for sub-requests)
 * @param {string} manifestUrl - The manifest URL we loaded (loadSource); has avh in query when private
 * @param {string|null} fallbackAvh - Token from API response when manifest URL has no avh
 * @returns {string} URL to use for the request (absolute, with avh when vod.api.video)
 */
export function ensureAvhForVodUrl(requestUrl, manifestUrl, fallbackAvh) {
  if (!requestUrl) return requestUrl;
  const req = String(requestUrl);
  let absolute = req;
  if (!req.startsWith('http://') && !req.startsWith('https://') && manifestUrl) {
    try {
      absolute = new URL(req, manifestUrl).href;
    } catch (_) {
      absolute = req;
    }
  }
  if (!absolute.includes('vod.api.video')) return absolute;
  if (/[?&]avh=/.test(absolute)) return absolute;
  const fromManifest = (manifestUrl && (String(manifestUrl).match(/[?&]avh=([^&]+)/) || [])[1])
    ? decodeURIComponent((String(manifestUrl).match(/[?&]avh=([^&]+)/) || [])[1])
    : null;
  const token = fromManifest || fallbackAvh;
  if (!token) return absolute;
  const sep = absolute.indexOf('?') >= 0 ? '&' : '?';
  return absolute + sep + 'avh=' + encodeURIComponent(token);
}
